import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, ButtonGroup, Well } from '@yapay/design-system'
import { withRouter, Link, Redirect } from 'react-router-dom'
import { generatePix, PIX_DID_GENERATE } from 'actions'
import OrderDetail from 'components/OrderDetail'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import imgPix from 'static/img/pix.svg'
import ReactGA from 'react-ga'
import Recaptcha from 'components/Recaptcha'

export class PixPayment extends Component {
  state = {
    tokenRecaptcha: '',
    dirtyPayButton: false,
  }

  pay = () => {
    const { isFetching } = this.props

    if (isFetching) {
      return
    }

    this.setState({ dirtyPayButton: true })

    if (!this.state.tokenRecaptcha) {
      return
    }

    const { dispatch, history, payParams, redirectUrl } = this.props

    return dispatch(
      generatePix({
        ...payParams,
        token_recaptcha: this.state.tokenRecaptcha,
      }),
    ).then(resp => {
      if (resp.type === PIX_DID_GENERATE) {
        ReactGA.event({
          category: 'Pix Payment',
          action: 'Pix Generated',
        })

        return history.replace(`/pagamento/${resp.data.transaction_token}`)
      }

      ReactGA.event({
        category: 'Pix Payment',
        action: 'Pix Fail',
      })

      history.replace(`/pix-falhou`, { redirectUrl })

      return null
    })
  }

  render() {
    const { isFetching, orderUndefined } = this.props

    if (orderUndefined) return <Redirect to="/nao-encontrado" />

    ReactGA.event({
      category: 'Choose Payment',
      action: 'Pix',
    })

    return (
      <div>
        <h2>Detalhes do pagamento</h2>

        <div className="flex items-center my-4">
          <MediaQuery query="(min-width: 768px)">
            <figure className="m-0 mr-4">
              <img src={imgPix} alt="Pix" width="110" height="110" />
            </figure>
          </MediaQuery>

          <div>
            <h3 className="text-gray-600 flex items-center">
              <MediaQuery query="(max-width: 767px)">
                <figure className="flex ml-0 mt-0 mb-0 mr-1">
                  <img src={imgPix} alt="Pix" width="auto" height="22" />
                </figure>
              </MediaQuery>
              Pix
            </h3>

            <p>
              Para seguir com o pagamento, clique na caixa de seleção abaixo e
              depois clique em “Gerar QR Code”.
            </p>
          </div>
        </div>

        <MediaQuery query="(max-width: 767px)">
          <Well className="p-4 md:p-4 -mx-4" plain>
            <OrderDetail />
          </Well>
        </MediaQuery>

        <div className="mb-4">
          <Recaptcha
            onChange={tokenRecaptcha => {
              this.setState({ tokenRecaptcha })
            }}
            invalid={!this.state.tokenRecaptcha && this.state.dirtyPayButton}
            errorMessage="Confirme o reCAPTCHA para continuar"
          />
        </div>

        <ButtonGroup responsive className="items-center">
          <Link to="/escolha-pagamento" className="button text-center px-0">
            Voltar
          </Link>
          <Button
            className="sm:w-64"
            color="info"
            id="button-pay"
            onClick={this.pay}
          >
            {isFetching ? 'Gerando...' : 'Gerar QR Code'}
          </Button>
        </ButtonGroup>
      </div>
    )
  }
}

PixPayment.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  orderUndefined: PropTypes.bool.isRequired,
  payParams: PropTypes.object.isRequired,
  redirectUrl: PropTypes.string,
}

const mapStateToProps = /* istanbul ignore next */ state => {
  const {
    transaction: {
      orderUndefined,
      order: { token, order_token, transaction_token, url_cancel, url_process },
    },
    user: { address_token, email },
    pix: { isFetching },
  } = state

  const redirectUrl = url_cancel || url_process || null

  const payParams = {
    token,
    seller_token: state.transaction.seller.token,
    address_token,
    payment_method: 'pix',
    order_token,
    transaction_token,
    payment_retry: state.transaction.paymentRetry,
    email,
  }

  if (state.transaction.type === 't') {
    payParams.customer = {
      name: state.user.name,
      company_name: state.user.company_name,
      email: state.user.email,
      cpf: state.user.cpf,
      cnpj: state.user.cnpj,
      zip_code: state.user.zip_code,
      street: state.user.street,
      number: state.user.number,
      neighborhood: state.user.neighborhood,
      city: state.user.city,
      state: state.user.state,
      phone: state.user.phone,
    }
  }

  return { payParams, redirectUrl, orderUndefined, isFetching }
}

export default withRouter(connect(mapStateToProps)(PixPayment))
